import React from 'react'

const SectionTextPictureImgFullH = ({ heading, contentStyle,styleList, content, imgSrc, imgAlt }) => {
  return (
    <div
      className={`${styleList} lg:px-0 container lg:flex lg:flex-row-reverse`}
    >
      <div
        className='lg:basis-1/2 lg:mx-0  xl:h-[1080px] lg:h-[768px] md:h-[600px] md:-mx-[45px] h-[375px] -mx-[24px]'
        data-aos='fade-up'
        data-aos-duration='500'
        data-aos-easing='ease-in-out'
      >
        <img
          src={imgSrc}
          alt={imgAlt}
          loading='lazy'
          className='w-full h-full object-cover'
        />
      </div>
      <div className='lg:flex lg:flex-col lg:justify-center pt-[40px] pb-[75px] lg:basis-1/2 lg:pl-[80px] md:pt-[135px] md:pb-[175px] lg:pt-[190px] lg:pb-[210px] '>
        <h2
          className='lg:max-w-[500px] mb-[24px] md:mb-[35px] text-4xl  md:text-4xl text-left'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {heading}
        </h2>
        <p
          className={`${contentStyle} lg:max-w-[500px] md:max-w-[650px] text-lg`}
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {content}
        </p>
      </div>
    </div>

  )
}



export default SectionTextPictureImgFullH



